import {Loan} from './loan.model';
import {Portfolio} from './portfolio.model';

export class GaugedInvestment {
    public readonly loan: Loan;
    public readonly amount: number;
    public readonly portfolio: Portfolio;

    constructor(loan: Loan, portfolio: Portfolio, amount: number) {
        this.loan = loan;
        this.amount = amount;
        this.portfolio = portfolio;
    }
}